<template>
    <div :class="{'form-floating': !simple}">
        <v-select :taggable="taggable" @listener :class="[background]" :placeholder="placeholder || trans('general.defaults.type_to_search')"
                  label="name" code="id" v-model="model" v-on="$listeners" @search="load" :filterable="false" :disabled="disabled ?? false"
                  :options="options">
            <template v-slot:option="option">
                {{ option.name }} {{ option.surname }}
            </template>
            <template #selected-option="{ name, surname }">
                {{ name }} {{ surname }}
            </template>
            <template v-slot:option="option">
                {{ option.name }} {{ option.surname }}
            </template>
        </v-select>
        <label v-if="!simple"> {{ label || trans('general.defaults.type_to_search') }}</label>
    </div>
</template>

<script>
import vSelect from "vue-select";

export default {
    name: "ChildFormSelect",
    props: {
        value: Object,
        type: String,
        name: String,
        placeholder: String,
        label: String,
        taggable: Boolean,
        background: String,
        simple: Boolean,
        disabled: Boolean
    },
    watch: {
        model: function (val) {
            this.$emit('change', val);
        },
        value: function (val) {
            (val && val.id) ? this.model = val : this.model = null;
        },
    },
    components: {
        vSelect
    },
    data() {
        return {
            model: null,
            options: []
        }
    },
    methods: {
        load(search) {
            this.search(search, this)
        },
        search: _.debounce((search, vm) => {
            axios.get(`/children`, {params: {limit: 15, search, search_fields: 'name:like', include:'parents'}})
                .then((response) => {
                    let data = response.data;
                    vm.options = data.data.data;
                });
        }, 350),

        setProduct(model) {
            this.model = model;
            this.options.push(model)
        }
    },
    mounted() {
        this.mode = this.type || this.mode;
        if (this.value) {
            this.model = this.value;
        }
        this.load()
    }
}
</script>

<style scoped>

</style>
